"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiInput = void 0;
const clsx_1 = __importDefault(require("clsx"));
const react_1 = __importStar(require("react"));
const __1 = require("../..");
function UiInput(_a) {
    var { value, onChangeValue, type, label, placeholder, size, clearable, booleanButtonProps, currency, adornmentStart, adornmentEnd, errorText, hasError, helperText, fullWidth, inputRef, options, children } = _a, rest = __rest(_a, ["value", "onChangeValue", "type", "label", "placeholder", "size", "clearable", "booleanButtonProps", "currency", "adornmentStart", "adornmentEnd", "errorText", "hasError", "helperText", "fullWidth", "inputRef", "options", "children"]);
    const [inputId] = react_1.useState(Math.random().toString());
    const isCurrency = Boolean(currency || type === 'currency');
    if (errorText) {
        hasError = true;
    }
    if (options) {
        type = 'select';
    }
    if (isCurrency) {
        type = 'number';
    }
    if (isCurrency && !adornmentEnd && currency) {
        adornmentEnd = (react_1.default.createElement(__1.UiButton, { size: size, variant: "text" }, currency));
    }
    size = size !== null && size !== void 0 ? size : 0;
    type = type !== null && type !== void 0 ? type : 'text';
    const valueFormatted = getFormattedValue(value);
    const hasValue = Boolean(valueFormatted) || valueFormatted === 0;
    function getFormattedValue(value) {
        if (isCurrency && value) {
            if (String(value).includes('.')) {
                return value;
            }
            return value / 100;
        }
        else if (['number', 'currency'].includes(type) && value === 0) {
            return '0';
        }
        else {
            return value || '';
        }
    }
    function handleChange(event) {
        var _a, _b;
        const { value } = event.target;
        if (['text', 'textarea'].includes(type)) {
            onChangeValue(value);
        }
        else if (['number', 'currency'].includes(type)) {
            if ((_a = value === null || value === void 0 ? void 0 : value.endsWith) === null || _a === void 0 ? void 0 : _a.call(value, '.')) {
                onChangeValue(value);
            }
            else if (value === '') {
                onChangeValue(undefined);
            }
            else if (isCurrency) {
                onChangeValue(Math.round(Number(value * 100)));
            }
            else {
                onChangeValue(Number(value * 1));
            }
        }
        else if (type === 'select') {
            onChangeValue((_b = options.find(option => option.value == value)) === null || _b === void 0 ? void 0 : _b.value);
        }
        else {
            onChangeValue(value);
        }
    }
    const className = clsx_1.default('UiInput', type && `type-${type}`, `size-${size}`, { hasValue, hasError });
    const propsLabel = {
        htmlFor: inputId,
        element: 'label',
    };
    const propsInput = Object.assign(Object.assign({}, rest), { value: valueFormatted || '', onChange: handleChange, id: inputId, placeholder: placeholder || label, ref: inputRef });
    return (react_1.default.createElement(__1.UiBox, { className: clsx_1.default(className, type && `type-${type}`), fullWidth: fullWidth },
        react_1.default.createElement(__1.UiFlex, Object.assign({}, propsLabel, { className: "input-container" }),
            label && type !== 'boolean' && react_1.default.createElement("span", { className: "label" }, label),
            adornmentStart,
            (type === 'boolean' && (react_1.default.createElement(__1.UiButton, Object.assign({ onClick: () => onChangeValue(!value), icon: value ? 'check_box' : 'check_box_outline_blank', size: size, color: hasValue ? 'secondary' : 'default', fullWidth: true, variant: "text" }, booleanButtonProps, { className: "button-boolean" }), label))) ||
                (type === 'select' && (react_1.default.createElement("select", Object.assign({}, propsInput),
                    react_1.default.createElement("option", { value: "", disabled: !clearable }, placeholder || label || 'Choose value'),
                    options.map(option => (react_1.default.createElement("option", { value: option.value, key: option.value }, option.label)))))) ||
                (type === 'textarea' && react_1.default.createElement("textarea", Object.assign({}, propsInput, { rows: 3 }))) || (react_1.default.createElement("input", Object.assign({}, propsInput, { type: type, size: 10 }))),
            clearable && value && (react_1.default.createElement(__1.UiButton, { onClick: () => onChangeValue(null), icon: "close", size: size, variant: "text" })),
            adornmentEnd),
        errorText && (react_1.default.createElement(__1.UiText, { color: "error", paddingLeft: 1, fontSize: -1 }, errorText)),
        helperText && (react_1.default.createElement(__1.UiText, { color: "text-secondary", paddingLeft: 1, fontSize: -1 }, helperText))));
}
exports.UiInput = UiInput;
